import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomRightClickComponent } from './custom-right-click/custom-right-click.component';



@NgModule({
  declarations: [CustomRightClickComponent],
  imports: [
    CommonModule
  ],
  exports: [
    CustomRightClickComponent
  ]
})
export class ContextMenuModule { }
